import { render, staticRenderFns } from "./LastTicketsDetailsHeader.vue?vue&type=template&id=0582e096&scoped=true"
import script from "./LastTicketsDetailsHeader.vue?vue&type=script&lang=js"
export * from "./LastTicketsDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsDetailsHeader.vue?vue&type=style&index=0&id=0582e096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0582e096",
  null
  
)

export default component.exports